import React from "react";
import "./index.css";
import { Link } from "react-router-dom";

export default () => {

    return(
        <>
            <div className="web-page-footer-socials-container">
                <a href={"https://twitter.com/J4crewyachting"} target={"_blank"} rel="noopener noreferrer" aria-label="Twitter">
                    <img src={require("../../assets/svgs/twitter-footer.svg")} alt="Twitter" />
                </a>
                <a href={"https://www.facebook.com/j4crewyachting"} target={"_blank"} rel="noopener noreferrer" aria-label="Facebook">
                    <img src={require("../../assets/svgs/facebook-footer.svg")} alt="Facebook" />
                </a>
                <a href={"https://www.instagram.com/j4crewyachting"} target={"_blank"} rel="noopener noreferrer" aria-label="Instagram">
                    <img src={require("../../assets/svgs/instagram-footer.svg")} alt="Instagram" />
                </a>
                <a href={"https://www.linkedin.com/company/5267269"} target={"_blank"} rel="noopener noreferrer" aria-label="LinkedIn">
                    <img src={require("../../assets/svgs/linkedin-footer.svg")} alt="LinkedIn" />
                </a>
            </div>
            <div className="web-page-footer-links-container" style={{ borderBottom: "1px solid rgb(225, 225, 225)" }}>
                <p><Link to={"/terms-and-conditions"}>Terms</Link><Link to={"/privacy-policy"}>Privacy Policy</Link><Link to={"/contact-us"}>Get in Touch</Link><Link to={"/about-us"}>About Us</Link><Link to={"/mlc-2006"}>MLC 2006</Link></p>
            </div>
            <div style={{height: 10}}></div>
            <div className="web-page-footer-links-container">
                <p>Copyright &copy;{new Date().getFullYear()} J4Crew LTD</p>
            </div>
            <div style={{height: 30}}></div>
        </>
    );

}
